import st from "@/styles/DashboardWideComponent.module.scss"
import DashboardSidebars from "@/components/SideElements/DashboardSidebars.tsx";
import React, {ReactNode, useEffect} from "react";
import clsx from "clsx";
import DashboardMobileHeader from "@/components/DashboardMobileHeader.tsx";
import ChevroneBtn from "@/ui/ChevroneBtn.tsx";
import {useNavigate} from "react-router-dom";
import CommonClass from "@/utils/common.ts";


interface Props {
    column_center: ReactNode
    header_content?: ReactNode
    heading: string
    responsive1?: boolean
    backUrl?: string
    onBackClick?():void
    hidden_back?:boolean
}


const DashboardWideComponent:React.FC<Props> = (props) => {
    
    const {
        column_center,
        heading,
        header_content,
        backUrl,
        onBackClick,
        hidden_back
    } = props
    const id = "appear_btn"
    const navigate = useNavigate()
    
    const backHandler = () => {
        if (typeof onBackClick === "function") {
            onBackClick()
        }
        
        if(typeof backUrl === "string") {
            navigate(backUrl)
        }
    }
    
    const showBackHandler = () => {
        
        if(window.innerWidth < CommonClass.breakpoints.breakpoint2) return
        
        let appear_btn = document.getElementById(id)
        
        if(appear_btn) {
            if(window.scrollY > 78) {
                appear_btn.classList.add(st.show)
            } else {
                appear_btn.classList.remove(st.show)
            }
        }
        
    }
    
    useEffect(() => {
        showBackHandler()
        
        window.addEventListener("scroll", showBackHandler)
        
        return () => {
            window.removeEventListener("scroll", showBackHandler)
        }
    }, [])
    
    return (
        <section className={clsx(st.main)}>
            
            <DashboardSidebars />
            
            <DashboardMobileHeader />
            
            {hidden_back && (
                
                <ChevroneBtn
                    id={id}
                    onClick={backHandler}
                    className={st.hidden_back}
                    direction={"left"}
                />
                
            )}
            
            <div className={st.header}>
                <div className={st.inner}>
                    {(typeof backUrl === "string" || typeof onBackClick === "function")&& (
                        
                        <ChevroneBtn
                            onClick={backHandler}
                            className={st.back}
                            direction={"left"}
                        />
                    )}
                    
                    <div className={st.heading}>
                        
                        {heading}
                        
                        {header_content && header_content}
                        
                    </div>
                    
                </div>
            </div>
            
            <div className={clsx(st.sides)}>
                
                <div className={st.inner}>
                    {column_center}
                </div>
            
            </div>
        
        
        </section>
    )
}


export default DashboardWideComponent